import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { UserContextProvider } from "./context/JobContext.tsx";
import { LoaderProvider } from "./context/loaderContext.tsx";
import { QuestionProvider } from "./context/QuestionNumberContext.tsx";
import { TimerProvider } from "./context/TimerContext.tsx";
import { BreadCrumbProvider } from "./context/BreadCrumbContext.tsx";
import { UserNameProvider } from "./context/UserNameContext.tsx";
import { JobDetailsProvider } from "./context/JobDetailsContext.tsx";
ReactDOM.createRoot(document.getElementById("root")!).render(
	<UserContextProvider>
		<LoaderProvider>
			<QuestionProvider>
				<TimerProvider>
					<BreadCrumbProvider>
						<UserNameProvider>
							<JobDetailsProvider>
								<App />
							</JobDetailsProvider>
						</UserNameProvider>
					</BreadCrumbProvider>
				</TimerProvider>
			</QuestionProvider>
		</LoaderProvider>
	</UserContextProvider>
);
